/* eslint-disable camelcase */
import { stringify } from 'query-string'
import { fetchUtils } from 'react-admin'
import moment from 'moment'
import postsProvider from './postsProvider'

const apiUrl = `${window.variables.urlSite}/wp-json/wp/v2`
const httpClient = fetchUtils.fetchJson

const promiseDelete = async (ressource, id) => {
  const myHeaders = new Headers()
  myHeaders.append('X-WP-Nonce', window.variables.nonce)
  myHeaders.append('Content-Type', 'application/json')

  if (!window.variables.callback_delete) {
    const requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      redirect: 'follow'
    }
    try {
      const res = await httpClient(
        `${apiUrl}/${ressource}/${id}?force=1`,
        requestOptions
      )
      const { json } = res
      return {
        json
      }
    } catch (e) {
      console.error('delete media', e)
      return false
    }
  }
  if (window.variables.callback_delete) {
    const data = JSON.stringify({ id })
    console.log('JSON data:', data)

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: data,
      redirect: 'follow'
    }

    const res = await fetch(
      `${window.variables.urlSite}/wp-json/video_tandem/v1/delete/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => result)
      .catch((error) => {
        console.log('error', error)
        return false
      })

    const json = res
    return {
      json
    }
  }
  return false
}
const videosProvider = {
  ...postsProvider,
  getList: async (ressource, params) => {
    const { page, perPage } = params.pagination
    const { field, order } = params.sort
    const { filter } = params

    let not_exist = ''
    let exist = ''

    const verifComa = (text) => (text === '' ? '' : ',')
    const constructNewQuery = (postMeta, name) => {
      if (JSON.parse(postMeta.toLowerCase())) {
        exist += `${verifComa(exist)}${name}`
      } else {
        not_exist += `${verifComa(not_exist)}${name}`
      }
    }
    const searchEmpty = ['link_photos', 'link_video', 'video_vue_par']

    searchEmpty.forEach((val) => {
      if (filter?.post_metas?.[val]) {
        constructNewQuery(filter?.post_metas?.[val], val)
      }
    })

    const query = {
      per_page: perPage,
      page,
      orderby: field,
      order: order.toLowerCase(),
      not_exist,
      exist,
      ...filter
    }
    if (filter?.post_metas?.videoman) {
      Object.assign(query, { videoman: filter?.post_metas?.videoman })
    }
    const res = await httpClient(`${apiUrl}/${ressource}?${stringify(query)}`)
    const { headers, json } = res
    return {
      data: json,
      total: +headers.get('X-WP-Total')
    }
  },

  getMany: async (post, params) => {
    const { ids } = params
    const query = {
      include: ids
    }
    const url = `${apiUrl}/${post}?${stringify(query)}`
    const res = await httpClient(url)
    const { json } = res
    return { data: json }
  },

  update: async (ressource, params) => {
    const { id, slug, status, post_metas, date } = params.data
    const prevVideo = await videosProvider.getOne(ressource, { id })
    const myHeaders = new Headers()
    myHeaders.append('X-WP-Nonce', window.variables.nonce)
    myHeaders.append('Content-Type', 'application/json')
    const data = {
      slug,
      status,
      title: `${post_metas?.nom} ${post_metas?.prenom} : ${moment(date).format(
        'DD-MM-YYYY'
      )}`,
      // meta	Meta fields.
      post_metas: {
        ...post_metas,
        video_ajouter_par:
          !prevVideo.link_video && post_metas.link_video
            ? window.variables.user.user_id
            : null,
        video_modifier_par: window.variables.user.user_id
      }
    }

    const raw = JSON.stringify(data)

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    console.log({data })

    const res = await httpClient(`${apiUrl}/${ressource}/${id}`, requestOptions)
    const { json } = res

    if (!post_metas?.mail_send && post_metas?.link_video) {
      const dataMail = new FormData()

      dataMail.append('action', 'send_ready_mail')
      dataMail.append('nonce', window.variables.nonce)
      dataMail.append('id', id)
      const resMail = await fetch(`${window.variables.ajaxUrl}`, {
        method: 'POST',
        credentials: 'same-origin',
        body: dataMail
      })
      const r = await resMail.json()
      console.log({ r, data: r.data })

      if (r?.data?.send) {
        const rawMail = JSON.stringify({
          ...data,
          post_metas: { ...data.post_metas, mail_send: moment().unix() }
        })
        requestOptions.body = rawMail
        await httpClient(`${apiUrl}/${ressource}/${id}`, requestOptions)

        window.alert('Le mail a bien été envoyé')
      } else {
        window.alert('Erreur')
      }
    }

    return {
      data: json
    }
  },
  create: async (ressource, params) => {
    const { post_metas, date } = params.data

    const myHeaders = new Headers()
    myHeaders.append('X-WP-Nonce', window.variables.nonce)
    myHeaders.append('Content-Type', 'application/json')

    const raw = JSON.stringify({
      status: 'publish',
      title: `${post_metas?.nom} ${post_metas?.prenom} : ${moment(date).format(
        'DD-MM-YYYY'
      )}`,
      post_metas,
      date: moment(date)

      // meta	Meta fields.
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }
    try {
      const res = await httpClient(`${apiUrl}/${ressource}`, requestOptions)
      const { json } = res
      return {
        data: json
      }
    } catch (e) {
      console.error('dsqfbqds', e)
      return null
    }
  },

  delete: async (ressource, params) => {
    const { id } = params
    const data = await promiseDelete(ressource, id)
    return { data }
  },

  deleteMany: async (ressource, params) => {
    const { ids } = params
    const promises = ids.map((id) => promiseDelete(ressource, id))
    const values = await Promise.all(promises)
    return {
      data: values
    }
  }
}
export default videosProvider
